let img = document.getElementById('aboutImageSmall');
let section = document.getElementById('about');

if(section) {
	section.addEventListener('mousemove', function(e) {
		let x = e.clientX / window.innerWidth;
		let y = e.clientY / window.innerHeight;
		img.style.transform = 'translate(' + x * 12 + '%, -' + y * 12 + '%)';
	});

	section.addEventListener('mouseout', function(e) {
		img.style.transform = 'translate(0px)';
	});
}